module.exports = __webpack_public_path__ + "img/package.5ad4a4e9.svg";